export const opcoesGrauAtividade = [
  { value: 1, label: "Inativo" },
  { value: 2, label: "Moderado" },
  { value: 3, label: "Ativo" },
];

export const opcoesCondicaoCorporal = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
};

export const opcoesTipoDieta = [
  { value: 1, label: "Manutenção" },
  { value: 2, label: "Crescimento" },
  { value: 3, label: "Lactação" },
  { value: 4, label: "Gestação" },
  { value: 5, label: "Emagrecimento" },
];